/**
 * Created by studio@linelab.pl on 2017-05-26.
 * @version 1.2.181011 - Add request-params
 * @version 1.3.200911 - Dodanie możliwość odświeżania segmentu załadowanego lub utworzonego dynamicznie.
 * @version 1.3.20091 - Dodanie data-ajax-url dla elementu select
 * @version 1.3.210320 - Dodanie obsługi data-loader-description dla data-ajax-url
 *
 */
(function ($) {

    pw.doc('Segment', '1.3.210320', ['segment:load[data-segment]', 'segment:reload[data-segment]']);

    $(document)
        .on('pw.segment', '[data-segment]', function (e, uri) {
            console.warn('Deprecated trigger: pw.segment use segment:load or segment:load.pw', 'Rewrite Event to segment:load.pw');
            $(this).trigger('segment:load.pw', [uri]);
        })
        // once load segment
        .on('segment:load.pw', '[data-segment]', function (e, uri) {

            e.stopPropagation();

            var u = $(this),
                url = uri || u.attr('data-segment'),
                disableCacheControl = !!(u.attr('data-segment-disable-cache-control')),
                wrapper = (u.attr('data-segment-target')) ? $(u.attr('data-segment-target')) : u,
                aParams = wrapper.data('requestParams'),
                sParams = wrapper.data('request-params')
            ;

            sParams = (sParams) ? sParams : {};

            var params = $.extend({}, sParams, aParams);

            if ((url && !wrapper.hasClass('pw-segment-loaded')) || uri) {

                    u.data('lastRequestUri', url);

                    wrapper.addClass('pw-segment-loaded').addClass('loading');

                    // if(!disableCacheControl) {
                    //     params['_timestamp_'] = Date.now()
                    // }

                $.ajax({
                    url: url,
                    data: params,
                    success: function(data) {
                        pw.ajaxContent.apply(e.target, [data, wrapper]);
                    },
                    cache: (!disableCacheControl)

                });

                    // if(disableCacheControl) {
                    //     $.get("" + url, params, function (data) {
                    //         pw.ajaxContent.apply(e.target, [data, wrapper]);
                    //     });
                    // } else {
                    //
                    // }

            }

        })
        // reload segment
        .on('segment:reload.pw', '[data-segment]', function (e, uri) {
            e.stopPropagation();

            var uie = $(this);

            if(uri === undefined && uie.data('lastRequestUri')) {
                uri = uie.data('lastRequestUri');
            }

            uie.removeClass('pw-segment-loaded')
                .trigger('segment:load.pw', [uri]);
        })
        // ajax buttons and url
        .on('click', 'a[data-ajax-url], button[data-ajax-url]', function (event) {

            var $e = $(this),
                url = (!$e.attr('data-ajax-url')) ? $e.attr('href') : $e.attr('data-ajax-url'),
                target = (($e.attr('data-target')) ? $($e.attr('data-target')) : $('body')),
                wrapper = target,
                m = $e.attr('data-target-method'),
                method =  m || 'append'
            ;


            if (url) {

                if($e.data('loaderDescription')) {
                    wrapper.data('loaderOnceDescription', $e.data('loaderDescription'));
                }

                event.preventDefault();
                wrapper.addClass('loading');
                $e.blur();

                $.get(url, function (data) {
                    pw.ajaxContent.apply(event.target, [data, wrapper, method]);
                });

            }
        })
        .on('change', 'select[data-ajax-url]', function (event) {

            var $e = $(this),
                url = (!$e.attr('data-ajax-url')) ? $e.val() : $e.attr('data-ajax-url'),
                target = (($e.attr('data-target')) ? $($e.attr('data-target')) : $('body')),
                wrapper = target,
                m = $e.attr('data-target-method'),
                method =  m || 'append'
            ;
            if (url) {

                event.preventDefault();
                wrapper.addClass('loading');

                $.get(url, function (data) {
                    pw.ajaxContent.apply(event.target, [data, wrapper, method]);
                });

            }
        })
        .on('click', '[data-segment-refresh]', function (e) {

            var selectors = $(this).attr('data-segment-refresh');

            if(selectors) {
                $(''+ selectors).trigger('segment:reload.pw');
            }

        });
    ;

    $(document).ready(function() {
        setTimeout(function () {
            $('[data-segment]').trigger('segment:load');
        }, 50);
    });



})(jQuery);